import React, { useState } from "react";
// import { Link } from "react-router-dom";

//
//

import LetheCityGrid from "./LetheCityGrid";
import LetheCityModal from "./LetheCityModal";

//

function LetheCity() {
  //
  //
  const [selectedImgLetheCity, setSelectedImgLetheCity] = useState(null);

  //
  //

  return (
    <React.Fragment>
      <LetheCityGrid setSelectedImgLetheCity={setSelectedImgLetheCity} />
      {/* {selectedImg &&
        the above means that only of this is true the rest
        will be rendered, in this case this:

        <FurnitureModal selectedImg={selectedImg} />

        I added this after adding the styles to the model, 
        in which i then realized that it was impossible to
        close the modal.
        
        
        */}
      {selectedImgLetheCity && (
        <LetheCityModal
          selectedImgLetheCity={selectedImgLetheCity}
          setSelectedImgLetheCity={setSelectedImgLetheCity}
        />
      )}

      {/* ------------- */}
      {/* ------------- */}
    </React.Fragment>
  );
}

export default LetheCity;
